module.exports = __webpack_public_path__ + "static/kv.3db32195c80f35f315e8dddbbe40bd9b.jpg";